import { render, staticRenderFns } from "./TransferCategorization.vue?vue&type=template&id=a4f5c736&"
import script from "./TransferCategorization.vue?vue&type=script&lang=js&"
export * from "./TransferCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports